export interface TypeSelectorProps {
  price: number
  onNextStep: VoidFunction
  onClose: VoidFunction
}

export enum SubscriptionType {
  ALL_SUBSCRIPTIONS = 'all_subscriptions',
  AI = 'ai_addon',
}
